// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// --- HS Code
import { ShellService } from '../core/services/shell.service';
import { accountRoutes } from './account.routes';

// #endregion

const routes: Routes = [
ShellService.childRoutes(accountRoutes)
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AccountRoutingModule { }
